import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=258a4337&scoped=true"
import script from "./Product.js?vue&type=script&lang=js&external"
export * from "./Product.js?vue&type=script&lang=js&external"
import style0 from "./Product.scss?vue&type=style&index=0&id=258a4337&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a4337",
  null
  
)

export default component.exports